import { Component, input } from '@angular/core';

import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import {
    TableRowData,
    hasPalletTickets,
} from '@app/shared/models/table-data-types';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';

@Component({
    selector: 'app-pallet-tickets-display',
    standalone: true,
    imports: [MatTooltipModule, TranslateModule],
    template: `
        @if (hasPalletTickets) {
            <img
                [matTooltip]="
                    'OUTGOING-GOODS.FOLDER-VIEW.HAS-PALLETTICKET' | translate
                "
                src="assets/images/load_carrier_icon.svg"
                alt="pallet ticket exists"
                width="23"
                height="23" />
        }
    `,
})
export class PalletTicketsDisplayComponent {
    value = input<ColumnValue>();
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);
    item = input<TableRowData>(); // legacy alias
    parentRow = input<TableRowData>(); // for expanded rows

    get rowData(): TableRowData {
        return (this.row() || this.item()) as TableRowData;
    }

    get hasPalletTickets(): boolean {
        const data = this.rowData;
        return hasPalletTickets(data) && data.palletTickets;
    }
}
